import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Device, ThirdPartyVendor } from '@/repositories/devices-repository'

export interface DevicesState {
    meters: Device[]
    inStoreVendors: ThirdPartyVendor[]
    allMeters: Device[]
    energyMeters: Device[]
    nonEnergyMeters: Device[]
    isFetchingMeters: boolean
    deviceBalance: string | null
    balanceLastUpdated: string | null
    balanceParsedInfoText: string | null
}

const initialState: DevicesState = {
    meters: [],
    inStoreVendors: [],
    allMeters: [],
    energyMeters: [],
    nonEnergyMeters: [],
    isFetchingMeters: false,
    deviceBalance: null,
    balanceLastUpdated: null,
    balanceParsedInfoText: null,
}

export const devicesStateSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<Partial<DevicesState>>) => {
            state.meters = action.payload.meters ?? state.meters
            state.inStoreVendors = action.payload.inStoreVendors ?? state.inStoreVendors
            state.allMeters = action.payload.allMeters ?? state.allMeters
            state.energyMeters = action.payload.energyMeters ?? state.energyMeters
            state.nonEnergyMeters = action.payload.nonEnergyMeters ?? state.nonEnergyMeters
            state.isFetchingMeters = action.payload.isFetchingMeters ?? state.isFetchingMeters
        },
        setIsFetchingMeters: (state, action: PayloadAction<boolean | undefined>) => {
            state.isFetchingMeters = action.payload ?? false
        },
        updateDeviceBalance: (state, action: PayloadAction<string | null>) => {
            state.deviceBalance = action.payload
        },
        updateBalanceDate: (state, action: PayloadAction<Date | null>) => {
            state.balanceLastUpdated = action.payload ? action.payload.toISOString() : null
        },
        updateParsedInfoText: (state, action: PayloadAction<string | null>) => {
            state.balanceParsedInfoText = action.payload
        },
        resetState: () => initialState,
    },
})

export const devicesStateActions = devicesStateSlice.actions
export type DevicesStateActions = typeof devicesStateActions
export default devicesStateSlice.reducer
